import { render } from "./ExpensesList.vue?vue&type=template&id=687eafb7&ts=true"
import script from "./ExpensesList.vue?vue&type=script&lang=ts"
export * from "./ExpensesList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__